import settings from './settings.coffee'


export default {
    install: (Vue, options)->
        Vue.djangows =
            callBackList: {
                onmessage: []
                onmodelsignals: {}
            }
            onmodelsignals: (options, cb)->
                if options.pk?
                    key = options.appLabel+"."+options.modelName+"."+options.pk
                else
                    key = options.appLabel+"."+options.modelName
                if not Vue.djangows.callBackList.onmodelsignals[key]?
                    Vue.djangows.callBackList.onmodelsignals[key] = []
                Vue.djangows.callBackList.onmodelsignals[key].push(cb)

        init = ()->
            ws = new WebSocket(settings.websocketUrl)
            ws.onmessage = (data)->
                for cb in Vue.djangows.callBackList.onmessage
                    cb(data)
                jsonData = JSON.parse(data.data)
                key = jsonData.app+"."+jsonData.model
                if Vue.djangows.callBackList.onmodelsignals[key]?
                    for cb in Vue.djangows.callBackList.onmodelsignals[key]
                        cb(jsonData)

                if jsonData.pk?
                    key += "."+jsonData.pk
                    if Vue.djangows.callBackList.onmodelsignals[key]?
                        for cb in Vue.djangows.callBackList.onmodelsignals[key]
                            cb(jsonData)
            ws.onopen = (evt)->
                # console.log("ws opened")
            ws.onclose = (evt)->
                # console.log("websocket onclose", evt)
                setTimeout(()->
                    Vue.djangows["socket"] = init()
                , 2000)
            ws.onerror = (evt)->
                # console.log("websocket onerror", evt)
            return ws

        Vue.djangows["socket"] = init()

        Vue.mixin({
            created: ()->
                this.$djangows = {}
                this.$djangows['callbacks'] = []
                vm = this
                this.$djangows['onmessage'] = (cb)->
                    Vue.djangows.callBackList.onmessage.push(cb)
                    vm.$djangows['callbacks'].push(cb)
                #this.$djangows['onmodelsignals'] = (appLabel, modelName, pk, cb)->
                this.$djangows['onmodelsignals'] = (options, cb)->
                    if options.pk?
                        key = options.appLabel+"."+options.modelName+"."+options.pk
                    else
                        key = options.appLabel+"."+options.modelName
                    if not Vue.djangows.callBackList.onmodelsignals[key]?
                        Vue.djangows.callBackList.onmodelsignals[key] = []
                    Vue.djangows.callBackList.onmodelsignals[key].push(cb)
                    vm.$djangows['callbacks'].push(cb)

            beforeDestroy: ()->
                i = 0
                for cb in Vue.djangows.callBackList.onmessage
                    for localCb in this.$djangows.callbacks
                        if cb == localCb
                            Vue.djangows.callBackList.onmessage.splice(i,1)
                    i += 1
                for key, cbs of Vue.djangows.callBackList.onmodelsignals
                    i = 0
                    for cb in cbs
                        if cb in this.$djangows.callbacks
                            Vue.djangows.callBackList.onmodelsignals[key].splice(i,1)
                        i += 1
                for key, val of this
                    if val? and val.hasOwnProperty? and val.hasOwnProperty("_isDataHolder")
                        for key, cbs of Vue.djangows.callBackList.onmodelsignals
                            i = 0
                            for cb in cbs
                                if cb == val.cb
                                    Vue.djangows.callBackList.onmodelsignals[key].splice(i,1)
                                i += 1

        })
}
